import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { sha256Hash } from '../sha256-hash';
import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onFollowUpSuggestionClick: ({
	followUpString,
	destination,
	...props
}: commonAttributesType & {
	followUpString: string;
	destination?: string;
}) => AnalyticsEventPayload = ({
	followUpString,
	destination,
	...props
}: commonAttributesType & {
	followUpString: string;
	destination?: string;
}): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiFollowUpSuggestion',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			followUpHash: sha256Hash(followUpString),
			destination,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
			followUpString,
		},
	};
};
